import React from "react";
import { Grid, Stack, Box, GTIWebButton, Typography, Avatar } from "@gti-controls-v2/web-core";
import { formatDateIsoDate } from "../../../common/utilities/dateTime";
import homePageStyles from "../../../common/styles/HomePage";

const HeaderInfo = ({employee, user, handleCloseTicket}) => {
    const styles = homePageStyles;

    return (
        <Grid container sx={{ backgroundColor: '#e9f7f6', alignItems: 'center', justifyContent: 'center', borderRadius: 2, padding: 2,}}>
            <Stack direction="row" spacing={4} sx={{ width: '100%' }}>
                <Stack direction="column" sx={{ flex: 1, }}>
                    <Box sx={{ marginBottom: 1, marginLeft: 4 }}>
                        <Avatar />
                    </Box>
                    <Box>
                        <Typography sx={{ fontWeight: 500, }}>
                            Nombre Completo:
                        </Typography>
                        <Typography variant="body2">
                            {employee.AutoUserName}
                        </Typography>
                    </Box>
                </Stack>

                <Stack direction="column" sx={{ flex: 1 }}>
                    <Box sx={{ marginBottom: 1 }}>                                
                        <Typography sx={{ fontWeight: 500, }}>
                            CURP:
                        </Typography>
                        <Typography variant="body2">
                            {employee.AutoUserCURP}
                        </Typography>
                    </Box>
                    <Box>
                        <Typography sx={{ fontWeight: 500, }}>
                            Último Timbrado:
                        </Typography>
                        <Typography variant="body2">
                            {formatDateIsoDate(employee?.EmpFinal)}
                        </Typography>
                    </Box>
                </Stack>

                <Stack direction="column" sx={{ flex: 1 }}>
                    <Box sx={{ marginBottom: 1 }}>
                        <Typography sx={{ fontWeight: 500, }}>
                            Puesto:
                        </Typography>
                        <Typography variant="body2">
                            {employee.NominaPuesto}
                        </Typography>
                    </Box>
                    <Box>
                        <Typography sx={{ fontWeight: 500, }}>
                            Último Login:
                        </Typography>
                        <Typography variant="body2">
                            {user?.UsuarioFechaAct ? formatDateIsoDate(user.UsuarioFechaAct, true) : ''}
                        </Typography>
                    </Box>
                </Stack>

                <Stack direction="column" sx={{ flex: 1, }}>
                    <Box sx={{ marginBottom: 1 }}>
                        <Typography sx={{ fontWeight: 500, }}>
                            Edad:
                        </Typography>
                        <Typography variant="body2">
                            {employee.Edad}
                        </Typography>
                    </Box>
                    <Box>
                        <GTIWebButton
                            name="createTicket"
                            type="submit"
                            text="Cerrar Ticket"
                            sx={styles.btnContinue}
                            onClick={handleCloseTicket}
                        />
                    </Box>
                </Stack>
            </Stack>
        </Grid>
    );
};

export default HeaderInfo;